/* Source: /home/sidsolaiyappan/skooch_ai/shared/jac_call.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { ensureJacSessionForOAuth } from "./oauth_session.js";
import { get_supabase } from "./supabase_config.js";
async function _jacFetchOnce(name, payload) {
  let _jt = localStorage.getItem("jac_token");
  let _hdrs = {"Content-Type": "application/json"};
  if (_jt) {
    _hdrs["Authorization"] = ("Bearer " + String(_jt));
  }
  return await fetch(("/function/" + name), {"method": "POST", "headers": _hdrs, "body": JSON.stringify(payload)});
}
async function skoochJacCallDirect(name, payload) {
  let _resp = await _jacFetchOnce(name, payload);
  if ((((_resp && (_resp.status === 401)) && window.__skoochIsOAuth) && !window.__skoochIsAnon)) {
    try {
      window.__skoochOAuthJacBound = false;
      let _u = await get_supabase().auth.getUser();
      let _reEmail = "";
      let _reUid = "";
      try {
        if (((_u && _u.data) && _u.data.user)) {
          _reEmail = String((_u.data.user.email || ""));
          _reUid = String((_u.data.user.id || ""));
        }
      } catch (__jac_e) {
        if (true) {
          let _eu = __jac_e;
        } else {
          throw __jac_e;
        }
      }
      if (_reUid) {
        await ensureJacSessionForOAuth(_reEmail, _reUid);
        _resp = await _jacFetchOnce(name, payload);
      }
    } catch (__jac_e) {
      if (true) {
        let _reErr = __jac_e;
        console.log("jac re-bind retry (non-fatal):", _reErr);
      } else {
        throw __jac_e;
      }
    }
  }
  if (!_resp.ok) {
    let _txt = await _resp.text();
    throw globalThis.Error(((("Function " + name) + " failed: ") + String(_txt)));
  }
  let _l = await _resp.json();
  if (!_l.ok) {
    let _emsg = "Unknown error";
    if (_l.error) {
      _emsg = String(_l.error);
    }
    throw globalThis.Error(((("Function " + name) + " failed: ") + _emsg));
  }
  let _result = null;
  try {
    if ((_l.data && _l.data.result)) {
      _result = _l.data.result;
    }
  } catch (__jac_e) {
    if (true) {
      let _e = __jac_e;
    } else {
      throw __jac_e;
    }
  }
  return _result;
}
export {_jacFetchOnce, skoochJacCallDirect};
if (typeof globalThis !== "undefined") { if (!globalThis.__jacEndpointEffects__) globalThis.__jacEndpointEffects__ = {}; Object.assign(globalThis.__jacEndpointEffects__, {"func:_jacFetchOnce": {"is_writer": false, "touches": ["*"]}, "func:skoochJacCallDirect": {"is_writer": true, "touches": ["*"]}}); };
//# sourceMappingURL=jac_call.js.map
